/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftBar = createReactComponent("arrow-left-bar", "IconArrowLeftBar", [
  ["path", { d: "M21 12h-18", key: "svg-0" }],
  ["path", { d: "M6 9l-3 3l3 3", key: "svg-1" }],
  ["path", { d: "M21 9v6", key: "svg-2" }]
]);

export { IconArrowLeftBar as default };
//# sourceMappingURL=IconArrowLeftBar.js.map
